var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiTelephoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88498 0.51017C2.05996 0.335459 2.27006 0.199929 2.50138 0.11256C2.7327 0.025192 2.97994 -0.012019 3.22672 0.00339321C3.47351 0.0188054 3.7142 0.0864889 3.93285 0.201958C4.15149 0.317428 4.34311 0.478046 4.49498 0.67317L6.28998 2.97917C6.61898 3.40217 6.73498 3.95317 6.60498 4.47317L6.05798 6.66317C6.0297 6.7766 6.03123 6.89541 6.06242 7.00808C6.09361 7.12075 6.1534 7.22343 6.23598 7.30617L8.69298 9.76317C8.77582 9.84592 8.87868 9.90581 8.99153 9.93701C9.10439 9.9682 9.22341 9.96964 9.33698 9.94117L11.526 9.39417C11.7826 9.33001 12.0504 9.32503 12.3093 9.3796C12.5681 9.43417 12.8111 9.54687 13.02 9.70917L15.326 11.5032C16.155 12.1482 16.231 13.3732 15.489 14.1142L14.455 15.1482C13.715 15.8882 12.609 16.2132 11.578 15.8502C8.93917 14.9217 6.54325 13.411 4.56798 11.4302C2.58727 9.45519 1.07659 7.05963 0.147983 4.42117C-0.214017 3.39117 0.110983 2.28417 0.850983 1.54417L1.88498 0.51017Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_4099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiTelephoneFill);
export default __webpack_public_path__ + "static/media/bi_telephone-fill.b3413e738ea434deb5756b5a6e030151.svg";
export { ForwardRef as ReactComponent };